let header = jQuery('.header')

jQuery('.body__before').on('click', function(e) {

    jQuery('.header .hamburger').trigger('click')

})

jQuery('.hamburger').on('click', function (e) {

    e.preventDefault()

    jQuery( '.ticket-popup' ).hide()

    if (jQuery(this).hasClass('is-active')) {
        jQuery('.drawer').attr('tabindex', '-1')
    } else {
        jQuery('.drawer').attr('tabindex', '1').focus()
    }

    jQuery('body').toggleClass('is-drawer')
    jQuery('.hamburger').toggleClass('is-active')

})

jQuery(document).on('keydown', function(event) {
    if (event.key == "Escape") {
        if( jQuery('body').hasClass('is-drawer') ){

            if (jQuery('.hamburger-toggle .hamburger').hasClass('is-active'))
                jQuery('.drawer').attr('tabindex', '-1')
            else
                jQuery('.drawer').attr('tabindex', '1').focus()

            jQuery('body').toggleClass('is-drawer')
            jQuery('.hamburger').toggleClass('is-active')
        }

    }
});

// jQuery(window).on('scroll', function () {
//     if (jQuery(window).scrollTop() > 0) {
//         header.addClass('header--white')
//     } else {
//         header.removeClass('header--white')
//     }
// })

jQuery('.drawer__nav .toggle').on('click', function (e) {

    e.preventDefault()

    let thisEl = jQuery(this),
        parentEl = thisEl.parent()

    if (parentEl.hasClass('open')) {
        parentEl.toggleClass('open').next().slideToggle()
    } else {
        jQuery('.drawer__nav .open').removeClass('open').next().slideToggle()
        parentEl.toggleClass('open').next().slideToggle()
    }

})


 jQuery('#language_checkbox').on('click', function (e) {
     if(jQuery(this).prop('checked'))
         location.href = jQuery('.fr').attr('data-lang');
    else
        location.href = jQuery('.en').attr('data-lang');
 })

 jQuery('#language_checkbox').prop('checked')


if(jQuery('.languages .languages__item').first().hasClass('active')){
    jQuery('.languages .languages__item:nth-child(2)').addClass('languages--left')
} else {
    jQuery('.languages .languages__item').first().addClass('languages--right')
}
